import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61b0dbf1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row gx-3 p-0 m-0" }
const _hoisted_2 = { class: "d-flex justify-content-between border-bottom pb-3 mb-2" }
const _hoisted_3 = { class: "header-height" }
const _hoisted_4 = {
  key: 0,
  class: "ms-4 badge bg-green"
}
const _hoisted_5 = {
  key: 0,
  class: "mt-lg-4 mt-2"
}
const _hoisted_6 = { class: "d-flex fw-bold align-items-center fs-7" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "d-flex fw-bold align-items-center fs-7"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "fw-bold fs-8 mb-lg-0 mb-2" }

import { translate } from '@/languages/i18n'
import Submenu from '@/components/submenu/index.vue'
import Button from '@/components/button/index.vue'
import DeleteGroupModal from '@/views/user/groups/components/DeleteGroupModal.vue'
import EditGroupModal from '@/views/user/groups/components/EditGroupModal.vue'
import LeaveInvitationGroupModal from '@/views/user/groups/components/LeaveInvitationGroupModal.vue'
import UserAliasIcon from '@/components/user-alias-icon'
import TargetTag from '@/components/target-tag/index.vue'
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { GROUPS_STORE } from '@/store/constants'
import groupsService from '@/services/groups.service'
import { numberWithCommas } from '@/components/comma-break/index.ts'
import PortfolioAlumni from '@/views/community-admin/user-management/alumni-user/detail/components/PortfolioAlumni.vue'
import PortfolioUser from '@/views/community-admin/user-management/employee-user/detail/components/PortfolioUser.vue'
import { ACCOUNT_STORE } from '@/store/constants'
import { Modal } from 'bootstrap'
import 'vue-toastification/dist/index.css'
import { useToast } from 'vue-toastification'
import ErrorToast from '@/components/toast-error/index404.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  paramGetGroup: Object,
},
  setup(__props) {

const props = __props

const toast = useToast()

const store = useStore()

const modal = ref()
const route = useRoute()
const listGroups = computed(() => {
  const getGroups = store.getters[GROUPS_STORE.GETTERS.LIST_GROUPS_LOAD_MORE]
  return getGroups?.listGroupsLoadMore.filter((item) => !item.invitation_group || (item.status === 2 && item.invitation_status === 2))
})

const showModal = computed(() => store.getters[ACCOUNT_STORE.GETTERS.PROFILE_DETAIL]?.showModal)

const group_id = ref<string | number>('')
const group_name = ref<string>('')
const leaveInvitationGroupSuccess = ref<boolean>(false)
// 2022/09/30 CW-Phuong Fix for UAT Phase2#4473: SN10 (Ph2-R20220930)


const ChangeEdit = (id: string | number, name: string) => {
  ;(group_id.value = id), (group_name.value = name)
}

const renderUserType = (user_type: any) => {
  if (user_type === 2) {
    return 'alumni'
  } else if (user_type === 1) {
    return 'employee'
  } else {
    return 'admin'
  }
}

const JoinGroup = async (id: string | number) => {
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN10 (Ph2-R20220930)
  document.getElementById(event.currentTarget.id).disabled = true
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN10 (Ph2-R20220930)
  try {
    const response = await groupsService.joinGroupApi(id)
    if (response?.status === 200) {
      store.dispatch(GROUPS_STORE.ACTIONS.JOIN_GROUP, id)
    } else if (response?.status !== 200) {
      // 2022/12/12 CW-PhuongTT Fix for UAT#5644: SN10 (Ph2-R20221222)
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'serverError4',
        },
      })
    }
  } catch (error) {
    console.log(error)
  }
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN10 (Ph2-R20220930)
  // document.getElementById(event.currentTarget.id).disabled = false
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN10 (Ph2-R20220930)
}
const ExitGroup = async (id: string | number) => {
  const buttonElement = document.getElementById(event.currentTarget.id)
  buttonElement.disabled = true
  try {
    const response = await groupsService.exitGroupApi(id)
    if (response?.status === 200) {
      store.dispatch(GROUPS_STORE.ACTIONS.EXIT_GROUP, id)
      leaveInvitationGroupSuccess.value = true
    } else if (response?.status !== 200) {
      leaveInvitationGroupSuccess.value = false
      toast.error({
        component: ErrorToast,
        props: {
          messageCode: 'serverError3',
        },
      })
    }
  } catch (error) {
    console.log(error)
  } finally {
    buttonElement.disabled = false
  }
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN10 (Ph2-R20220930)
  // document.getElementById(event.currentTarget.id).disabled = false
  // 2022/09/26 CW-NamPH7425 Fix for UAT#4495: SN10 (Ph2-R20220930)
}

const handleShowUser = async (id, userID, userType) => {
  if (userType === 'community_admin') {
    return
  }
  modal.value = new Modal(document.getElementById(userType === 'alumni' ? 'editProfileModal' : 'profileUserModal'))
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, { id, userID, userType })
  if (showModal.value) {
    await modal.value?.show()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listGroups), (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-lg-6 gx-0 gx-lg-4",
          key: item
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(['px-2 py-3 shadow bg-white group-container p-lg-4  mb-lg-4 mb-3', [1, 2].includes(item?.status) ? 'box-group' : ''])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_router_link, {
                    to: 
                  [1, 2].includes(item?.status)
                    ? `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}/groups/${item?.id}/talk_rooms`
                    : `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}/groups/${item?.id}/users`
                ,
                    class: "fw-bold fs-6 mb-3 text-black text-header"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item?.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (item?.invitation_group === true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(translate)('inviteOnlyGroup')), 1))
                    : _createCommentVNode("", true)
                ]),
                (item?.admin?.user_type === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(UserAliasIcon), {
                          userType: item?.admin?.user_type
                        }, null, 8, ["userType"]),
                        _createElementVNode("span", null, _toDisplayString(item?.admin?.display_name), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "mt-lg-4 mt-2 cursor-pointer",
                      onClick: () => handleShowUser(_unref(route)?.params?.id, item?.admin?.id, renderUserType(item?.admin?.user_type))
                    }, [
                      ([1, 2].includes(item?.admin?.user_type))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_unref(UserAliasIcon), {
                              userType: item?.admin?.user_type
                            }, null, 8, ["userType"]),
                            _createElementVNode("span", null, _toDisplayString(item?.admin?.display_name), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_7))
              ]),
              (item?.status === 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (ChangeEdit(item?.id, item?.name)),
                    class: "ms-3"
                  }, [
                    _createVNode(Submenu, {
                      dataBs: [
                ['modal', '#editGroupDefault'],
                ['modal', '#deleteGroupAlumni'],
              ],
                      menu: [
                { title: _unref(translate)('groupEditing') },
                {
                  title: _unref(translate)('deleteGroupChat'),
                },
              ]
                    }, null, 8, ["menu"])
                  ], 8, _hoisted_9))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_router_link, {
              to: 
            [1, 2].includes(item?.status)
              ? `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}/groups/${item?.id}/talk_rooms`
              : `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}/groups/${item?.id}/users`
          ,
              class: "text-black text-decoration-none"
            }, {
              default: _withCtx(() => [
                _createVNode(TargetTag, {
                  data: item?.information,
                  class: "information mb-3"
                }, null, 8, ["data"])
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("div", {
              class: _normalizeClass(['d-flex flex-column flex-xl-row justify-content-between align-items-center', item?.status === 1 && 'defined-height'])
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(_unref(translate)('participantGroup')) + "： ", 1),
                _createVNode(_component_router_link, {
                  to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}/groups/${item?.id}/users`,
                  class: "fw-bold fs-8 mb-3 text-black"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(numberWithCommas)(item?.members)), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createTextVNode(_toDisplayString(_unref(translate)('name')), 1)
              ]),
              ([3].includes(item?.status))
                ? (_openBlock(), _createBlock(Button, {
                    key: 0,
                    id: `${item?.id}`,
                    title: _unref(translate)('join'),
                    type: 'secondary',
                    onClick: ($event: any) => (JoinGroup(item?.id)),
                    size: 'small',
                    className: 'fw-bold'
                  }, null, 8, ["id", "title", "onClick"]))
                : _createCommentVNode("", true),
              ([2].includes(item?.status))
                ? (_openBlock(), _createBlock(Button, {
                    key: 1,
                    id: `${item?.id}`,
                    title: _unref(translate)('exit'),
                    type: 'secondary',
                    onClick: ($event: any) => (item?.invitation_group ? ChangeEdit(item?.id, item?.name) : ExitGroup(item?.id)),
                    dataBsToggle: item?.invitation_group ? 'modal' : '',
                    dataBsTarget: item?.invitation_group ? '#leaveInvitationGroup' : '',
                    size: 'small',
                    className: 'fw-bold'
                  }, null, 8, ["id", "title", "onClick", "dataBsToggle", "dataBsTarget"]))
                : _createCommentVNode("", true)
            ], 2)
          ], 2)
        ]))
      }), 128))
    ]),
    _createVNode(EditGroupModal, { groupId: group_id.value }, null, 8, ["groupId"]),
    _createVNode(DeleteGroupModal, {
      groupId: group_id.value,
      groupName: group_name.value,
      paramGetGroup: __props.paramGetGroup
    }, null, 8, ["groupId", "groupName", "paramGetGroup"]),
    _createVNode(LeaveInvitationGroupModal, {
      name: group_name.value,
      leaveGroupSuccess: leaveInvitationGroupSuccess.value,
      onLeaveInvitationGroup: _cache[0] || (_cache[0] = ($event: any) => (ExitGroup(group_id.value)))
    }, null, 8, ["name", "leaveGroupSuccess"]),
    _createVNode(PortfolioAlumni),
    _createVNode(PortfolioUser)
  ], 64))
}
}

})